import FKIntro from './fk-intro';
import FKAbout from './fk-about';
import FKBranding from './fk-branding';
import FKMerch from './fk-merch';
import FKApplication from './fk-application';
import FKContact from './fk-contact';

function FitKonnektPage() {
  return (
    <div>
      <FKIntro />
      <FKAbout />
      <FKBranding />
      <FKMerch />
      <FKApplication />
      <FKContact />
    </div>
  );
}

export default FitKonnektPage;
